var map = {
	"./ReportForms0.png": "tIQj",
	"./ReportForms1.png": "ScF9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FVMP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/ReportForms.*\.png$
// module id = FVMP
// module chunks = 3